import { module } from 'modujs';
import barba from '@barba/core';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
        this.scrollYHistory = [0];
        this.firstLoad = true;
    }

    init() {
      console.log('init Load')
      history.scrollRestoration = "manual";
      

      barba.hooks.afterLeave((data) => {
        this.call('menuClose', null, 'Search');
        this.call('destroy', data.current.container, 'app');
        data.current.container.style.display = 'none';
      
      });

      barba.hooks.beforeEnter((data) => {
        if(this.firstLoad) {
          this.firstLoad = false;
        } else {
          //Hacky fix to beat race condition on iOS chrome.
          setTimeout(() => {
            this.call('update', data.next.container, 'app');
            if(data.trigger !== "back") {
              this.scrollYHistory.push(barba.history.current.scroll.y);
              window.scrollTo(0,0);
            } else {
              window.scrollTo(0, this.scrollYHistory.pop());
            }
          }, 200);
        }
      });


      barba.init({
        preventRunning: true,
        transitions: [{
            name: 'default-transition',
            leave(data) {
              return gsap.to(data.current.container, {
                opacity: 0,
                duration: 0.2
              });
            },
            enter(data) {
              return gsap.from(data.next.container, {
                delay: 0.3,
                opacity: 0,
                duration: 0.2
              });
            }
        }]
      });
    }
}
